// https://platform.openai.com/docs/guides/speech-to-text/supported-languages

export const AILanguageOptions = [
  { value: "British English", label: "🇬🇧 English (UK)" },
  { value: "American English", label: "🇺🇸 English (US)" },
  { value: "French", label: "🇫🇷 French" },
  { value: "Spanish", label: "🇪🇸 Spanish" },
  { value: "German", label: "🇩🇪 German" },
  { value: "Arabic", label: "🇸🇦 Arabic" },
  { value: "Afrikaans", label: "🇿🇦 Afrikaans" },
  { value: "Armenian", label: "🇦🇲 Armenian" },
  { value: "Azerbaijani", label: "🇦🇿 Azerbaijani" },
  { value: "Belarusian", label: "🇧🇾 Belarusian" },
  { value: "Bosnian", label: "🇧🇦 Bosnian" },
  { value: "Bulgarian", label: "🇧🇬 Bulgarian" },
  { value: "Catalan", label: "🇨🇭 Catalan" },
  { value: "Chinese", label: "🇨🇳 Chinese" },
  { value: "Croatian", label: "🇭🇷 Croatian" },
  { value: "Czech", label: "🇨🇿 Czech" },
  { value: "Danish", label: "🇩🇰 Danish" },
  { value: "Dutch", label: "🇳🇱 Dutch" },
  { value: "Estonian", label: "🇪🇪 Estonian" },
  { value: "Finnish", label: "🇫🇮 Finnish" },
  { value: "Galician", label: "🇪🇸 Galician" },
  { value: "Greek", label: "🇬🇷 Greek" },
  { value: "Hebrew", label: "🇮🇱 Hebrew" },
  { value: "Hindi", label: "🇮🇳 Hindi" },
  { value: "Hungarian", label: "🇭🇺 Hungarian" },
  { value: "Icelandic", label: "🇮🇸 Icelandic" },
  { value: "Indonesian", label: "🇮🇩 Indonesian" },
  { value: "Italian", label: "🇮🇹 Italian" },
  { value: "Japanese", label: "🇯🇵 Japanese" },
  { value: "Kannada", label: "🇮🇳 Kannada" },
  { value: "Kazakh", label: "🇰🇿 Kazakh" },
  { value: "Korean", label: "🇰🇷 Korean" },
  { value: "Latvian", label: "🇱🇻 Latvian" },
  { value: "Lithuanian", label: "🇱🇹 Lithuanian" },
  { value: "Macedonian", label: "🇲🇰 Macedonian" },
  { value: "Malay", label: "🇲🇾 Malay" },
  { value: "Marathi", label: "🇮🇳 Marathi" },
  { value: "Maori", label: "🇳🇿 Maori" },
  { value: "Nepali", label: "🇳🇵 Nepali" },
  { value: "Norwegian", label: "🇳🇴 Norwegian" },
  { value: "Persian", label: "🇮🇷 Persian" },
  { value: "Polish", label: "🇵🇱 Polish" },
  { value: "Portuguese", label: "🇵🇹 Portuguese" },
  { value: "Romanian", label: "🇷🇴 Romanian" },
  { value: "Russian", label: "🇷🇺 Russian" },
  { value: "Serbian", label: "🇷🇸 Serbian" },
  { value: "Slovak", label: "🇸🇰 Slovak" },
  { value: "Slovenian", label: "🇸🇮 Slovenian" },
  { value: "Swahili", label: "🇰🇪 Swahili" },
  { value: "Swedish", label: "🇸🇪 Swedish" },
  { value: "Tagalog", label: "🇵🇭 Tagalog" },
  { value: "Tamil", label: "🇮🇳 Tamil" },
  { value: "Thai", label: "🇹🇭 Thai" },
  { value: "Turkish", label: "🇹🇷 Turkish" },
  { value: "Ukrainian", label: "🇺🇦 Ukrainian" },
  { value: "Urdu", label: "🇵🇰 Urdu" },
  { value: "Vietnamese", label: "🇻🇳 Vietnamese" },
  { value: "Welsh", label: "🏴󠁧󠁢󠁷󠁬󠁳󠁿 Welsh" },
];